import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export function AuthPageLoader() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        py: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress color="primary" aria-label={t('common.loadingPage')} />
    </Box>
  );
}
